import { Action, createReducer, on } from '@ngrx/store'
import { LoadEntityTagsComplete, SetEntityTagsComplete } from './actions'
import { adapter, initialState, State } from './state'

export const reducer = createReducer(
  initialState,
  on(LoadEntityTagsComplete, (state, { items }) => adapter.setAll(items, { ...state, isLoaded: true })),
  on(SetEntityTagsComplete, (state, { item }) => adapter.setOne(item, state))
)

export function tagsReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectAll } = adapter.getSelectors()
